const generatePolishPostCode = (code: string) => {
  const districtCode = code.slice(0, 2);
  const areaCode = code.slice(2);
  return `${districtCode}-${areaCode}`;
};

export default generatePolishPostCode;
